import { appApiSystemAdmin } from 'constants/ApiConstant';
import { profilesKeys } from '../keys';
import useHttpClient from 'hooks/useHttpClient';
import { useQuery } from '@tanstack/react-query';

export function useGetUsers(props) {
  const { token, get } = useHttpClient();

  const queryRequest = useQuery({
    queryKey: profilesKeys.users.queryKey,
    enabled: !!token,
    queryFn: async () =>
      await get({
        url: `${appApiSystemAdmin}/users/detail`,
      }),
    select: (res) => {
      return res?.data || undefined;
    },
    throwOnError: (err) => {
      if (props?.onError) {
        props?.onError?.(err);
      }
    },
  });

  return queryRequest;
}
